export function colorLuminance(rawHex, lum) {
  if (lum === void 0) {
    lum = 0;
  }

  // validate hex string
  var hex = String(rawHex).replace(/[^0-9a-f]/gi, '');

  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  } // convert to decimal and change luminosity


  var rgb = '#';

  for (var i = 0; i < 3; i++) {
    var c = hex && parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    rgb += ("00" + c).substr(c.length);
  }

  return rgb;
}
export function getGradient(degree, color) {
  return "linear-gradient(" + degree + ", " + colorLuminance("#" + color, +0.09) + ", " + colorLuminance("#" + color, -0.09) + ")";
}
/**
 * Возвращает цвет по строке
 *
 * @param {string} string строка имени
 * @param {Array} colors массив цветов (hex коды или имёна)
 * @return {string} цвет из массива цветов
 */

export var getColorByString = function getColorByString(string, colors) {
  var i = string.length;
  var sum = 0;

  while (i--) {
    sum += string.charCodeAt(i);
  }

  return colors ? colors[sum % colors.length] : null;
};